var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.count && _vm.props.count > 0)?_c('b-badge',{staticClass:"counter",attrs:{"variant":_vm.props.variant}},[(Number(_vm.props.count) <= Number(_vm.props.maxCount))?[_vm._v(_vm._s(_vm.props.count))]:[_vm._v(_vm._s(_vm.props.maxCount)+"+")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }